<div class="bg-warning" #warning_message tabindex="-1">
  <div class="container text-black">
    <div class="row align-items-md-center justify-content-lg-center" [ngClass]="{'py-3': small, 'py-4': !small}">
      <div class="col-3 col-md-2 mb-md-0 text-md-end" [ngClass]="{'mb-4': !small}">
        <span *ngIf="small">
          <app-info-circle [size]="2"></app-info-circle>
        </span>
        <span *ngIf="!small">
          <app-info-circle [size]="4"></app-info-circle>
        </span>
      </div>
      <div class="col-9">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
